<div class="level-container h-100 mt-4 pb-3 ms-auto me-auto">
  <div class="mt-3 level-title">
    <h2 class="pt-4 ms-4">{{ selectedlevel ? 'Editar Nivel' : 'Añadir Nivel' }}</h2>
  </div>
  <div class="body p-4">
    <div class="row">
      <div class="col-12">
        <span class="mb-1 w-100">Nombre*</span>
        <input
          id="name"
          class="w-100"
          type="text"
          [(ngModel)]="name"
          (input)="validateName($event)"
          placeholder="Nombre del nivel"
          maxlength="25"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <span class="mb-1 w-100">Puntos requeridos*</span>
        <input
          id="requiredPoints"
          class="w-100"
          type="number"
          (input)="validateMax($event)"
          (keydown)="validateOnlyNumbers($event)"
          [(ngModel)]="requiredPoints"
          placeholder="Puntos requeridos"
          maxlength="8"
          required
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <span class="mb-1 w-100">Color*</span>
        <div class="row w-100 m-0 p-0">
          <div class="col-1 p-0">
            <div
              class="color-square col-3"
              [style.background]="color"
              [(colorPicker)]="color"
            ></div>
          </div>
          <div class="col-11 p-0">
            <input
              class="color-input col-9"
              id="color"
              [(colorPicker)]="color"
              [value]="color"
              type="text"
              [cpOutputFormat]="'hex'"
              readonly
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row buttons-footer justify-content-end buttons-level">
    <button id='cancelButton'class="ind-button-lite" (click)="cancelClick()">
      <span class="text-buttons">Cancelar</span>
    </button>

    <button id="saveButton" class="ind-button" (click)="onSubmit()">
      <span class="text-buttons">Guardar</span>
    </button>
  </div>
</div>
